import mongoose from "mongoose";
import { match } from "@mssi/pssp-shared";

export interface ProviderContract {
  _id: mongoose.Schema.Types.ObjectId;
  providerContractId: string;
  endCustomerAccountId: string;
  resellerAccountId?: number;
  providerContractNumber: string;
  state: string; // expect Active
  masterAgreementId: string;
  soldToBpId?: string; // partners.[partnerType=SOLD_TO].partnerId
  endUserBpId?: string; // partners.[partnerType=END_USER_BP].partnerId
  subProductIds: string[]; // subProducts[].productId
  refreshId?: string;
}

export const ProviderContractSchema = new mongoose.Schema<ProviderContract>({
  providerContractId: { type: String, index: true, unique: true },
  endCustomerAccountId: { type: String, index: true },
  resellerAccountId: String,
  providerContractNumber: String,
  state: String,
  masterAgreementId: String,
  soldToBpId: String,
  endUserBpId: String,
  subProductIds: [String],
  refreshId: String,
});

export const props: (keyof ProviderContract)[] = [
  "providerContractId",
  "endCustomerAccountId",
  "resellerAccountId",
  "providerContractNumber",
  "state",
  "masterAgreementId",
  "soldToBpId",
  "endUserBpId",
  "subProductIds",
];

export function matches(a: ProviderContract, b: ProviderContract): boolean {
  return match(a, b, props);
}

export const providerContractUtils = {
  props,
  matches,
};
